const isImage = (content_type: string): boolean =>
  ["image/gif", "image/jpeg", "image/png"].includes(content_type);
const isVideo = (content_type: string): boolean =>
  content_type.startsWith("video/");
const isNativelySupportedVideo = (content_type: string): boolean =>
  ["video/mp4", "video/mpeg", "video/ogg"].includes(content_type);
const isAudio = (content_type: string): boolean =>
  ["audio/mpeg", "audio/ogg", "audio/mp4", "audio/wav", "audio/x-wav"].includes(
    content_type,
  );
const isPDF = (content_type: string): boolean =>
  content_type.startsWith("application/pdf");

export const contentTypeParser = {
  isImage,
  isVideo,
  isNativelySupportedVideo,
  isAudio,
  isPDF,
};

export const supportsGalleryPreview = (content_type: string): boolean =>
  isImage(content_type) || isNativelySupportedVideo(content_type);
